import React, { useState } from "react"
import styled from "styled-components"

import addToMailchimp from "gatsby-plugin-mailchimp"

import { useForm } from "react-hook-form"

import { yupResolver } from "@hookform/resolvers/yup"

import * as yup from "yup" // for everything

import { One, Input } from "components/inputs"

import { glassStyle } from "utils"

// https://www.gatsbyjs.com/plugins/gatsby-plugin-mailchimp/?=mailchimp

const isProd =
  process.env.NODE_ENV === "production" &&
  process.env.GATSBY_ENV === "production"

// const isProd = true

const defaultValues = {
  email: "",
  name: "", // honeypot
}

const schema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .email("valid email is required")
    .required("email is required"),
})

const NewsLetterForm = () => {
  const [formMsg, setFormMsg] = useState()

  const {
    handleSubmit,
    register,
    reset,
    setError,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  })

  const onSubmit = async (values) => {
    if (!values.name && isProd) {
      try {
        const { msg, result } = await addToMailchimp(values.email)

        if (result === "success") {
          reset(defaultValues)
        } else {
          reset(values)
        }
        setFormMsg(msg) // set msg reguardless
      } catch (err) {
        setError("email", {
          type: "manual",
          message: "Sorry an unknown error occured, please try again.",
          shouldFocus: true,
        })
      }
    } else {
      reset()
      setError("email", {
        type: "manual",
        message: "Not Submitted, Not Production",
        shouldFocus: true,
      })
    }
  }
  return (
    <StyledNewsLetterForm
      id="newsLetterForm"
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      {formMsg ? (
        <FormMsg dangerouslySetInnerHTML={{ __html: formMsg }} />
      ) : (
        <>
          <p className="form-title">Stay in the loop with our newsletter:</p>
          <Input
            errors={errors}
            className="name"
            id="name"
            type="text"
            name="name"
            placeholder="name"
            register={register}
          />
          <One
            className="email"
            type="email"
            name="email"
            placeholder="enter email address"
            errors={errors}
            register={register}
            isSubmitting={isSubmitting}
            required
          />
        </>
      )}
    </StyledNewsLetterForm>
  )
}

const StyledNewsLetterForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .form-title {
    margin-bottom: var(--sp-16);
  }

  .name-wrap {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -99;
    height: 0;
  }
`

const FormMsg = styled.p`
  ${glassStyle};
  text-align: center;
  padding: var(--sp-16);
  max-width: 540px;
`

export default NewsLetterForm
